import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import Axios from "axios";
import "./CreateShipment.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";

const GeneratedTablePage = () => {
  const { numRows } = useParams();
  const location = useLocation();
  const barcodeInputRef = useRef(null);
  const selectRef = useRef(null);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [currentScanIndex, setCurrentScanIndex] = useState(0);
  const [numRowsIndex, setNumRowsIndex] = useState(1);
  const [scanHistory, setScanHistory] = useState([]);
  const shipmentData = location.state?.shipmentData || null;
  const [Data, setData] = useState([]);
  const [currentSectionCount, setCurrentSectionCount] = useState(0);
  const [quantityMatch, setQuantityMatch] = useState(true);

  const allSKUs = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => orderDetail.SKU)
  );

  const allquantity = shipmentData?.ShipmentDetails.flatMap((detail) =>
    detail.OrderDetails.map((orderDetail) => ({
      SKU: orderDetail.SKU,
      approvedquantity: orderDetail.approvedquantity,
    }))
  );

  const isScanningCompleted = currentScanIndex >= parseInt(numRows);

  const handleAddBarcode = (barcode) => {
    if (!selectedOrderId) {
      swal({
        title: "Please Select Order ID",
        text: "",
        icon: "warning",
      });
      return;
    }
    if (barcode) {
      const matchedItem = Data.find((item) =>
        item.barcodeData?.includes(barcode)
      );

      const containsSKU = allSKUs.some((sku) => barcode.includes(sku));

      if (matchedItem) {
        const allScannedBarcodes = [...scannedBarcodes];
        scanHistory.forEach((scan) => {
          allScannedBarcodes.push(...scan.scannedData);
        });

        if (allScannedBarcodes.includes(barcode)) {
          alertify.error("Barcode already scanned!");
          barcodeInputRef.current.value = "";
        } else if (!containsSKU) {
          alertify.error("Barcode does not contain any SKU!");
          barcodeInputRef.current.value = "";
        } else {
          if (currentSectionCount + 1 !== totalQuantity) {
            setQuantityMatch(false);
          } else {
            setQuantityMatch(true);
          }

          const skuInBarcode = allSKUs.find((sku) => barcode.includes(sku));
          const skuCountInAllScannedBarcodes = allScannedBarcodes.filter((b) =>
            b.includes(skuInBarcode)
          ).length;
          const approvedQuantityForSKU = allquantity.find(
            (q) => q.SKU === skuInBarcode
          ).approvedquantity;

          if (skuCountInAllScannedBarcodes >= approvedQuantityForSKU) {
            alertify.error(
              `SKU ${skuInBarcode} has reached its approved quantity!`
            );
            barcodeInputRef.current.value = "";
            return;
          }

          setScannedBarcodes((prevBarcodes) => [...prevBarcodes, barcode]);
          setCurrentSectionCount((prevCount) => prevCount + 1);
          barcodeInputRef.current.value = "";
          barcodeInputRef.current.focus();

          alertify.success(`Barcode Scanned: ${barcode}`);
        }
      } else {
        alertify.error("Barcode not found!");
        barcodeInputRef.current.value = "";
      }
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setData(response.data);
      }
    );
  }, []);

  const handleNextScan = () => {
    if (!isScanningCompleted) {
      const scannedData = scannedBarcodes;
      const newScan = {
        numRows: numRowsIndex,
        scannedData,
        count: scannedBarcodes.length,
        OrderNumber: selectedOrderId,
      };
      setScanHistory((prevHistory) => [...prevHistory, newScan]);

      setCurrentScanIndex((prevIndex) => prevIndex + 1);
      setNumRowsIndex((prevIndex) => prevIndex + 1);
      setScannedBarcodes([]);
      setSelectedOrderId("");
      barcodeInputRef.current.focus();
    }
  };

  useEffect(() => {
    if (isScanningCompleted) {
      alertify.success("Scanning completed!");
    }
  }, [isScanningCompleted]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const barcode = e.target.value;
      handleAddBarcode(barcode);
    }
  };

  useEffect(() => {
    const clickHandler = (e) => {
      if (
        e.target !== barcodeInputRef.current &&
        e.target !== selectRef.current
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", clickHandler);

    return () => {
      document.removeEventListener("click", clickHandler);
    };
  }, []);

  const totalCount = scanHistory.reduce((total, scan) => total + scan.count, 0);

  const totalQuantity = shipmentData?.totalQuantity || 0;

  const handleCreateOutbound = async () => {
    if (!isScanningCompleted) {
      alertify(
        "Scanning is not completed. Please finish scanning before creating outbound."
      );
      return;
    }

    const shipmentDataToPost = {
      totalCount: totalCount,
      totalBoxes: shipmentData.totalBoxes,
      totalWeight: shipmentData.totalWeight,
      barcodeData: scanHistory.map((scan) => ({
        BoxNo: scan.numRows,
        scannedData: scan.scannedData,
        count: scan.count,
        DistributorName: scan.DistributorName,
        OrderNum: scan.OrderNumber,
      })),
    };

    try {
      const postResult = await Axios.post(
        `${INVENTORY_API_BASE_URL}/createshipment`,
        shipmentDataToPost
      );

      for (let index = 0; index < scanHistory.length; index++) {
        const scan = scanHistory[index];
        const scannedDataToSend = scan.scannedData;

        const deleteResult = await Axios.delete(
          `${INVENTORY_API_BASE_URL}/putawayOutbound`,
          {
            data: { barcodeData: scannedDataToSend },
          }
        );

        swal({
          title: `Barcode Data Removed for Scan ${index + 1}`,
          text: "",
          icon: "success",
        });
      }

      window.location.reload();
    } catch (error) {
      alertify("Service error");
      console.error(error);
    }
  };

  return (
    <div className="generated-table-page-container">
      <main className="generated-content">
        <header className="generated-hero">
          <div>
            <span className="generated-eyebrow">
              <span className="generated-eyebrow-mark" />
              OUTBOUND OPERATIONS
            </span>
            <h1>Pack and scan shipment</h1>
            <p>Assign approved orders to boxes and scan each barcode before creating the outbound shipment.</p>
          </div>
          <span className={"generated-status" + (isScanningCompleted ? " generated-status-complete" : "")}>
            <span />
            {isScanningCompleted ? "All boxes scanned" : "Scanning in progress"}
          </span>
        </header>

        <section className="generated-summary-grid" aria-label="Shipment progress">
          <article className="generated-summary-card">
            <span>Current box</span>
            <strong>{isScanningCompleted ? numRows : numRowsIndex}<small> / {numRows}</small></strong>
            <small>{isScanningCompleted ? "Box scanning complete" : "Box being packed"}</small>
          </article>
          <article className="generated-summary-card">
            <span>Scanned quantity</span>
            <strong>{currentSectionCount}<small> / {totalQuantity}</small></strong>
            <small>Approved book quantity</small>
          </article>
          <article className="generated-summary-card">
            <span>In this box</span>
            <strong>{scannedBarcodes.length}</strong>
            <small>Barcodes scanned</small>
          </article>
          <article className="generated-summary-card">
            <span>Shipment weight</span>
            <strong>{shipmentData?.totalWeight || 0}<small> kg</small></strong>
            <small>Estimated packed weight</small>
          </article>
        </section>

        <section className="generated-progress-card">
          <div className="generated-progress-copy">
            <div>
              <span className="generated-section-eyebrow">QUANTITY CHECK</span>
              <strong>{currentSectionCount} of {totalQuantity} approved books scanned</strong>
            </div>
            <span className={currentSectionCount === totalQuantity ? "generated-match-pill" : "generated-progress-pill"}>
              <span />
              {currentSectionCount === totalQuantity ? "Quantity matched" : "In progress"}
            </span>
          </div>
          <div
            className="generated-progress-track"
            role="progressbar"
            aria-label="Approved quantity scanned"
            aria-valuemin={0}
            aria-valuemax={totalQuantity}
            aria-valuenow={currentSectionCount}
          >
            <span
              style={{
                width: Math.min(
                  totalQuantity ? (currentSectionCount / totalQuantity) * 100 : 0,
                  100
                ) + "%",
              }}
            />
          </div>
        </section>

        <section className="generated-scanner-grid">
          <div className="generated-panel generated-scanner-panel">
            <div className="generated-panel-heading">
              <div>
                <span className="generated-section-eyebrow">ACTIVE BOX · {numRowsIndex}</span>
                <h2>Scan barcodes</h2>
                <p>Select the order assigned to this box, then scan or enter its barcode.</p>
              </div>
              <span className="generated-box-icon" aria-hidden="true">BOX</span>
            </div>

            <label className="generated-field">
              <span>Order ID for this box</span>
              <select
                ref={selectRef}
                value={selectedOrderId}
                onChange={(e) => setSelectedOrderId(e.target.value)}
                disabled={isScanningCompleted}
              >
                <option value="">Select an order</option>
                {shipmentData?.ShipmentDetails?.map((detail) => (
                  <option key={detail.orderId} value={detail.orderId}>
                    {detail.orderId}
                  </option>
                ))}
              </select>
            </label>

            <label className="generated-field generated-barcode-field">
              <span>Barcode</span>
              <div className="generated-barcode-control">
                <span className="generated-barcode-icon" aria-hidden="true">⌕</span>
                <input
                  type="text"
                  placeholder="Scan or enter barcode"
                  ref={barcodeInputRef}
                  onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                  onKeyDown={handleKeyDown}
                  disabled={isScanningCompleted || currentSectionCount === totalQuantity}
                  autoComplete="off"
                />
                <span className="generated-enter-hint">Press Enter</span>
              </div>
            </label>

            <div className="generated-scanner-actions">
              <button
                className="generated-add-button"
                type="button"
                onClick={() => handleAddBarcode(barcodeInputRef.current.value)}
                disabled={isScanningCompleted}
              >
                Add barcode
              </button>
              <button
                className="generated-next-button"
                type="button"
                onClick={handleNextScan}
                disabled={isScanningCompleted}
              >
                Save box &amp; next <span aria-hidden="true">→</span>
              </button>
            </div>

            <div className={quantityMatch ? "generated-scan-message" : "generated-scan-message generated-scan-message-warning"}>
              <span aria-hidden="true">{quantityMatch ? "✓" : "!"}</span>
              {quantityMatch
                ? "Barcodes are checked against the selected order quantities."
                : "Keep scanning until the approved quantity check is satisfied."}
            </div>
          </div>

          <aside className="generated-panel generated-quick-summary">
            <span className="generated-section-eyebrow">SHIPMENT OVERVIEW</span>
            <h2>At a glance</h2>
            <div className="generated-overview-row">
              <span>Total boxes</span>
              <strong>{shipmentData?.totalBoxes || numRows}</strong>
            </div>
            <div className="generated-overview-row">
              <span>Total book quantity</span>
              <strong>{totalQuantity}</strong>
            </div>
            <div className="generated-overview-row">
              <span>Completed boxes</span>
              <strong>{scanHistory.length} of {numRows}</strong>
            </div>
            <div className="generated-overview-note">
              Complete each planned box scan before creating the outbound shipment.
            </div>
          </aside>
        </section>

        <section className="generated-detail-grid">
          <div className="generated-panel">
            <div className="generated-panel-heading generated-panel-heading-compact">
              <div>
                <span className="generated-section-eyebrow">PACKING LOG</span>
                <h2>Box scan history</h2>
              </div>
              <span className="generated-count-chip">{scanHistory.length} saved</span>
            </div>
            {scanHistory.length === 0 ? (
              <div className="generated-empty">Saved box scans will appear here.</div>
            ) : (
              <div className="generated-history-list">
                {scanHistory.map((scan, index) => (
                  <article className="generated-history-item" key={index}>
                    <span className="generated-history-box">BOX {scan.numRows}</span>
                    <div className="generated-history-copy">
                      <strong>Order {scan.OrderNumber}</strong>
                      <span>{scan.count} {scan.count === 1 ? "barcode" : "barcodes"} scanned</span>
                    </div>
                    <span className="generated-history-check" aria-label="Saved">✓</span>
                  </article>
                ))}
              </div>
            )}
          </div>

          <div className="generated-panel">
            <div className="generated-panel-heading generated-panel-heading-compact">
              <div>
                <span className="generated-section-eyebrow">CURRENT BOX</span>
                <h2>Scanned barcodes</h2>
              </div>
              <span className="generated-count-chip">{scannedBarcodes.length} scanned</span>
            </div>
            {scannedBarcodes.length === 0 ? (
              <div className="generated-empty">Barcode entries will appear here.</div>
            ) : (
              <ul className="generated-barcode-list">
                {scannedBarcodes.map((barcode, index) => (
                  <li key={index}>
                    <span className="generated-barcode-bullet" />
                    <code>{barcode}</code>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </section>

        {quantityMatch && (
          <footer className="generated-outbound-footer">
            <div>
              <span className="generated-section-eyebrow">READY FOR DISPATCH</span>
              <strong>{isScanningCompleted ? "All boxes are ready" : "Finish scanning all boxes"}</strong>
              <span>
                {isScanningCompleted
                  ? "Create the outbound record and remove scanned barcodes from shelf stock."
                  : "Complete the planned box scans to enable outbound creation."}
              </span>
            </div>
            <button
              onClick={handleCreateOutbound}
              className="outboundbtn"
              disabled={!isScanningCompleted}
            >
              Create outbound <span aria-hidden="true">→</span>
            </button>
          </footer>
        )}
      </main>
    </div>
  );
};

export default GeneratedTablePage;
